const maxLines = {
  mounted(el, binding) {
    el.classList.add('lines-clamped')
    el.style.webkitLineClamp = binding.value
  }
}

export default maxLines
